import packages from '../../js/package';
// import original from '../../js/original';
import '../css/style.scss';

// npmでインストールしたパッケージの読み込み
packages();

// オリジナルパーツ読み込み
// original();


// 新規のコードはこのカッコの中に記載してください。

// PC/SP振り分け（必要なときに使ってください。）
jQuery(function() {
  var windowWidth = jQuery(window).width();
  var windowSm = 768;
  if (windowWidth <= windowSm) {
      //横幅768px以下のとき（つまりスマホ時）に行う処理を書く

  
  } else {
      //横幅840px超のとき（タブレット、PC）に行う処理を書く
  }
});
    
window.onload = function () {
  
  // ハンバーガーメニュー
  jQuery(function() {
    var state = false;
    var pos;
    jQuery('.navToggle').click(function() {
        jQuery(this).toggleClass('active');

        if (state == false) {
                pos = jQuery(window).scrollTop();
                jQuery('body').addClass('active').css({'top': -pos});
                jQuery('#gnav').addClass('active');
                jQuery('.main-header').addClass('active');
                state = true;
            } else {
                jQuery('body').removeClass('active').css({'top': 0});
                jQuery('#gnav').removeClass('active');
                jQuery('.main-header').removeClass('active');
                window.scrollTo(0, pos);
                state = false;
            }
    });
        // メニュー外をタップした時：SP用
        jQuery(document).on('touchstart',function(e) {
                  if(!jQuery(e.target).closest('#nav').length) {
                      // ターゲット要素の外側をタップした時の操作
            jQuery('.navToggle').removeClass('active');
            jQuery('#gnav').removeClass('active');
            jQuery('body').removeClass('active').css({'top': 0});
            jQuery('.main-header').removeClass('active');

                  } else {
                      // ターゲット要素をタップした時の操作（今回は不要）
              }
        });
        // メニュー外をクリックした時：PC用
        jQuery(document).on('click',function(e) {
                  if(!jQuery(e.target).closest('#nav').length) {
                      // ターゲット要素の外側をクリックした時の操作
            jQuery('.navToggle').removeClass('active');
            jQuery('#gnav').removeClass('active');
            jQuery('body').removeClass('active').css({'top': 0});

                  } else {
                      // ターゲット要素をクリックした時の操作（今回は不要）
              }
        });
  });


  // ページトップへのボタン（スクロール＆出現タイミング）
  jQuery(function() {
    var topBtn = jQuery('#page-top');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
  });

  //ページ内スムーススクロール
  jQuery(function(){
    jQuery('a[href^="#"]').click(function() {
      var speed = 400;
      var href= jQuery(this).attr("href");
      var target = jQuery(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
  });

  // グロナビアコーディオン
  jQuery('#gnav .detail_nav > li').find('h2').on('click', function(){
    jQuery(this).next('#gnav .detail_nav > li .outer-underlayer_nav').slideToggle();
    jQuery(this).toggleClass('open');
    jQuery(this).parent().toggleClass('open');
    jQuery('#gnav .detail_nav > li h2').not(jQuery(this)).next('#gnav .detail_nav > li .outer-underlayer_nav').slideUp();
    jQuery('#gnav .detail_nav > li h2').not(jQuery(this)).removeClass("open");
    jQuery('#gnav .detail_nav > li h2').not(jQuery(this)).parent().removeClass("open");
  });

  // MVスライダー
  jQuery(function() {
    jQuery('.mv_slider').slick({
        dots:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        speed: 2000,
        pauseOnHover: false,
      });

      jQuery(".mv_slider")
      // 最初のスライドに"add-animation"のclassを付ける(data-slick-index="0"が最初のスライドを指す)
      .on("init", function () {
        jQuery('.slick-slide[data-slick-index="0"]').addClass("add_animation");
      })
      .on({
        // スライドが移動する前に発生するイベント
        beforeChange: function (event, slick, currentSlide, nextSlide) {
          // 表示されているスライドに"add-animation"のclassをつける
          jQuery(".slick-slide", this).eq(nextSlide).addClass("add_animation");
          // あとで"add-animation"のclassを消すための"remove-animation"classを付ける
          jQuery(".slick-slide", this).eq(currentSlide).addClass("remove_animation");
        },
        // スライドが移動した後に発生するイベント
        afterChange: function () {
          // 表示していないスライドはアニメーションのclassを外す
          jQuery(".remove_animation", this).removeClass(
            "remove_animation add_animation"
          );
        },
      });
  });

  // 採用情報スライダー
  jQuery(function() {
    jQuery('.recruit_slider').slick({
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1500,

        responsive: [
            {
              breakpoint: 480,
              settings: {
              slidesToShow: 1,
              },
            },
          ],
        });
  });

  // ふわっとアニメーション
  jQuery('.fadeInUp').on('inview', function(event, isInView) {
    if (isInView) {//表示領域に入った時
      jQuery(this).addClass('fadeUp');//クラス名が付与
    } else {//表示領域から出た時
    //   jQuery(this).removeClass('fadeUp');//クラス名が除去
    }
  });

  // 高さを揃える
  // jQuery(function() {
  //     jQuery('#curriculum_flow>li ul.weekly>li').matchHeight();
  // });

  // スクロールイベント：ヘッダー
  jQuery(function () {
  const header = jQuery('body');
    jQuery(window).scroll(function () {
      if (jQuery(this).scrollTop() >= 100) {
        header.addClass('change-color');
      } else {
        header.removeClass('change-color');
      }
    });
  });

  // スクロールバー幅を取得（親要素をぶち抜いて横幅100vwにする.over_parent用）
  jQuery(function () {
  const setScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    // カスタムプロパティの値を更新する
    document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
  };

  // 表示されたとき
  window.addEventListener('load', setScrollbarWidth);
  // リサイズしたとき
  window.addEventListener('resize', setScrollbarWidth);
  });

}
